import script from "./loan-repayments-report-table.vue?vue&type=script&setup=true&lang=js"
export * from "./loan-repayments-report-table.vue?vue&type=script&setup=true&lang=js"

import "./loan-repayments-report-table.vue?vue&type=style&index=0&id=5555a8d0&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5555a8d0"]])

export default __exports__